import * as React from 'react';
import Typography from '@mui/material/Typography';
import {
    Button, Card, CardActionArea, CardContent, CardMedia,
    Grid, InputAdornment, MenuItem,
    TextField, Tooltip, useTheme
} from "@mui/material";
import {
    ArrowBackIos, ArrowForwardIos, Assignment,
    Info,
    Person
} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useState} from "react";
import {selectRequestState, setFare, setItem, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import {coin, pair} from "../../inc/Utils";
import Pic from "../../inc/Pic";
import {selectUser} from "../../store/userSlice";
import Api from "../../inc/Api";
import Alert from "../../inc/Alert";
import useDidMountEffect from "../../inc/hooks/use_did_mount_effect";

function Step2() {

    const theme = useTheme();
    const {item, fare} = useSelector(selectRequestState);
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const [capacities] = useState(() => {
        let max_capacity_1 = 0;

        for (let pr of fare.products) {
            if (pr.capacity_1 > max_capacity_1) {
                max_capacity_1 = pr.capacity_1;
            }
        }

        return Array(max_capacity_1).fill(0).map((v, i) => pair(`${i + 1}`, `${i + 1}`));
    });

    useDidMountEffect(loadFare, [item.capacity_1]);

    function loadFare() {
        setLoading(true);
        Api.post(`/widgets/${item.id_widget}/fare`, item, rsp => {
            setLoading(false);
            if (rsp.ok) {

                dispatch(setFare(rsp));

                if (item.product) {
                    dispatch(setItem({
                        product: rsp.products.find(o => o.id === item.product.id && !o.error),
                    }));
                }

            } else {
                Alert.error(rsp.msg);
            }
        });
    }

    return (
        <Body title="Seleccione servicio">

            <Grid container spacing={3}>

                <Grid xs={12} item>

                    <Grid container spacing={3}>

                        {fare.products.map(pr => {
                            let enabled = !pr.error && !loading;
                            return (
                                <Grid item xs={6} sm={3} md={2} lg={2}>
                                    <Card
                                        key={pr.id}
                                        variant="elevation"
                                        sx={{
                                            opacity  : enabled ? 1.0 : 0.5,
                                            boxShadow: item.product && item.product.id === pr.id
                                                ? `0 0 0 5px ${theme.palette.primary.main}`
                                                : undefined,
                                        }}>
                                        <CardActionArea
                                            sx={{
                                                cursor: enabled ? 'pointer' : 'default',
                                            }}
                                            disableRipple={!enabled}
                                            onClick={enabled ? () => dispatch(setItem({product: pr})) : undefined}>

                                            <CardMedia
                                                image={Pic.url(pr.pic)}
                                                sx={{height: 80}}/>

                                            <CardContent sx={{pb: 1}}>

                                                <Typography color="textPrimary">
                                                    {pr.name}
                                                </Typography>

                                                {pr.surname && (
                                                    <Typography color="textPrimary" variant="caption" sx={{
                                                        whiteSpace  : 'nowrap',
                                                        maxWidth    : '100%',
                                                        textOverflow: 'ellipsis',
                                                    }}>
                                                        {pr.surname}
                                                    </Typography>
                                                )}

                                                <Typography color="textPrimary" sx={{mt: 1, textAlign: 'right'}}>
                                                    {pr.error ? (
                                                        <Tooltip title={pr.error}>
                                                            <Info color="error" fontSize="inherit"
                                                                  sx={{cursor: 'help'}}/>
                                                        </Tooltip>
                                                    ) : (
                                                        <b>{coin(pr.fare.price)}</b>
                                                    )}
                                                </Typography>

                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            );
                        })}

                    </Grid>

                </Grid>

                <Grid xs={12} sm={4} item>

                    <TextField
                        label="Pasajeros"
                        value={item.capacity_1}
                        onChange={e => dispatch(setItem({capacity_1: e.target.value}))}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    disablePointerEvents
                                    sx={{mr: 3, position: 'absolute', top: 'calc(50%)', right: 12}}>
                                    <Person color="primary"/>
                                </InputAdornment>
                            ),
                        }}
                        disabled={loading}
                        select>
                        {capacities.map(o => <MenuItem key={o.id} value={o.id}>{o.name}</MenuItem>)}
                    </TextField>

                </Grid>

                <Grid xs={12} sm={8} item>

                    <TextField
                        label="Observaciones, cantidad de maletas"
                        value={item.notes}
                        onChange={e => dispatch(setItem({notes: e.target.value}))}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Assignment color="primary"/>
                                </InputAdornment>
                            ),
                        }}
                        disabled={loading}/>

                </Grid>

                <Grid md={6} item display={{xs: 'none', md: 'block'}}/>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        startIcon={<ArrowBackIos/>}
                        onClick={() => {
                            dispatch(setStep('1'));
                        }}
                        color="secondary"
                        disabled={loading}
                        fullWidth>
                        Volver
                    </Button>

                </Grid>

                <Grid xs={6} md={3} item>

                    <Button
                        variant="contained"
                        endIcon={<ArrowForwardIos/>}
                        onClick={() => {
                            if (user) {
                                dispatch(setStep('4'));
                            } else {
                                dispatch(setStep('3_check'));
                            }
                        }}
                        disabled={loading || !item.product}
                        fullWidth>
                        Siguiente
                    </Button>

                </Grid>

            </Grid>
        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step2));